module.exports = __webpack_public_path__ + "img/icon_FISH.b396bbd1.png";